import { render, staticRenderFns } from "./SanctionReport.vue?vue&type=template&id=1a386462"
import script from "./SanctionReport.vue?vue&type=script&lang=js"
export * from "./SanctionReport.vue?vue&type=script&lang=js"
import style0 from "./SanctionReport.vue?vue&type=style&index=0&id=1a386462&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports